import {
  Button,
  IconButton,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import styled from "styled-components";
import TrackedLink from "./TrackedLink";

const Container = styled.div`
  text-align: center;
  width: 100%;
`;

const BootstrapDialogTitle = ({ children, onClose, ...other }) => {
  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
};

const ToolExplanationDialog = ({ open, handleClose }) => {
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <BootstrapDialogTitle onClose={handleClose} id="alert-dialog-title">
        Tool Explanation
      </BootstrapDialogTitle>
      <DialogContent>
        <p>
          Podium Prepper saves you time when creating flashcards for oral argument.
          Our AI-enabled tool extracts information from the brief to automatically generate flashcards.
        </p>
        <p>
          As a reminder, before using AI on client work please review and comply with Orrick Risk Management Policy 51 
          and any Client AI restrictions, both available on the <TrackedLink 
          href="https://theportal.orrick.com/Firm/Orrick-AI" target="_blank" rel="noreferrer">Portal - Orrick.AI</TrackedLink>.
        </p>
      </DialogContent>
      <DialogActions>
        <Container>
          <Button onClick={handleClose} autoFocus>
            OK
          </Button>
        </Container>
      </DialogActions>
    </Dialog>
  );
};

export default ToolExplanationDialog;
